import React from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';

import { isListingFavourite } from './favouriteUtils';
import { useUpdateProfileMutation } from './UserApi';
import IconHeart from './IconHeart';

import css from './FavouriteListing.module.css';

const FavouriteListing = ({ className, listing }) => {
  const currentUser = useSelector(state => state.user.currentUser);
  const [updateProfile, { isLoading }] = useUpdateProfileMutation();
  const isFavourite = isListingFavourite({ currentUser, listing });

  const handleToggle = e => {
    e.stopPropagation();
    e.preventDefault();

    if (isLoading || !currentUser) return;

    const favouriteListings =
      currentUser?.attributes?.profile?.protectedData?.favouriteListings || [];
    const listingId = listing?.id?.uuid;

    const updated = isFavourite
      ? favouriteListings.filter(id => id !== listingId)
      : [...favouriteListings, listingId];

    updateProfile({ protectedData: { favouriteListings: updated } });
  };

  if (!currentUser) return null;

  return (
    <div
      className={classNames(css.root, className)}
      onClick={handleToggle}
      role="button"
      tabIndex={0}
    >
      <IconHeart className={css.icon} isFilled={isFavourite} />
    </div>
  );
};

export default FavouriteListing;
